import { bindable } from "aurelia";

export class MtButton {
  @bindable disabled = false;
  @bindable onclick: () => void;
  @bindable label = "";
  @bindable loading = false;
}
